import React from 'react';
import { css } from 'styled-components';

//components
import Layout from 'src/components/common/theme/Layout';

//helpers
import { checkValue } from 'src/components/common/helper';

//types
import { HeroGardientProps } from '../../typings';

const HeroGradient: React.FC<HeroGardientProps> = (props) => {
  const { opacitySelect  , template} = props;

  const moduleCss = () => {
    const opacity = checkValue(opacitySelect) ? parseInt(opacitySelect) / 100 : 1;

    return `
            &.hero-gradient-component{
                opacity : ${opacity} !important
            }
        `;
  };

  return (
    <Layout
      className={`hero-gradient-component ${template}`}
      css={css`
        ${moduleCss()}
      `}
    ></Layout>
  );
};

export default HeroGradient;
